<template>
  <v-card v-resize="onResize">
    <v-app-bar
      absolute
      color="white"
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
    >
      <v-toolbar-title class="hidden-sm-and-down ml-5">
        Billing
      </v-toolbar-title>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="primary"
      ></v-progress-linear>

      <v-spacer></v-spacer>

      <v-btn depressed class="blue" dark @click="resetInvoices()">
        Reset All Invoices
      </v-btn>
      <v-spacer></v-spacer>

      <v-checkbox
        v-model="noEmail"
        label="Do Not Email"
        color="error"
        hide-details
      ></v-checkbox>

      <v-text-field
        v-model="search"
        label="Search Companies"
        prepend-icon="mdi-magnify"
        v-on:keyup="searchCompanies"
        clearable
        @click:clear="clearMessage"
        hide-details
        class="hidden-sm-and-down pl-4"
      />
    </v-app-bar>

    <v-sheet
      v-resize="onResize"
      :height="height"
      id="scrolling-techniques-7"
      class="overflow-y-auto"
    >
      <v-container style="margin-top: 70px; margin-bottom: 70px; padding: 0;">
        <v-card>
          <v-virtual-scroll
            :bench="benched"
            :items="showCompanies"
            :height="height - 80"
            item-height="64"
          >
            <template v-slot:default="{ item }">
              <v-list-item :key="item.id">
                <v-list-item-icon>
                  <v-btn icon :to="`company/${item.id}`">
                    <v-icon color="primary">mdi-pencil</v-icon>
                  </v-btn>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <div v-if="item.invoice === 'Paid'"></div>
                  <v-btn
                    v-else-if="item.payStatus"
                    depressed
                    class="blue"
                    dark
                    @click="editCertificate(item)"
                  >
                    Send Certificate
                  </v-btn>
                  <v-btn
                    v-else
                    depressed
                    class="red lighten-1"
                    dark
                    @click="editInvoice(item)"
                  >
                    ${{ item.amount }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-card>
      </v-container>
    </v-sheet>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Send Invoice</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="sendInfo.amount"
                  label="Amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="sendInfo.CertificateId"
                  :items="certificates"
                  item-text="name"
                  item-value="id"
                  label="Certificate Type"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="sendInfo.emailTo"
                  label="Send To"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.native="dialog = !dialog">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click.native="sendInvoice">
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="certDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Send Certificate</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="sendInfo.startDate"
                  label="Start Date"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                  v-model="sendInfo.noEmail"
                  label="Do Not Email"
                  color="error"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="sendInfo.emailTo"
                  label="Send To"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click.native="certDialog = !certDialog"
          >
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click.native="sendCertificate">
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import _ from 'lodash'
import Api from '@/services/Api'
import moment from 'moment'

export default {
  name: 'billings',

  data: () => ({
    benched: 0,
    certDialog: false,
    certificates: [],
    companies: [],
    company: {},
    dialog: false,
    disable: true,
    height: 400,
    indeterminate: false,
    loading: true,
    logo: '',
    menu: false,
    noEmail: false,
    numberSelected: 'Select All',
    search: '',
    selectAll: false,
    selected: [],
    showCompanies: [],
    snackbar: {
      show: false,
      color: '',
      message: '',
    },
    team: '',
    sendInfo: {},
  }),

  created() {
    this.getCompanies()
    this.getCertificates()
  },

  mounted() {
    this.onResize()
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 120
    },

    async getCompanies() {
      const clientId = this.$store.state.client.id

      try {
        const response = await Api().get('companies_billing/' + clientId)

        const companies = response.data
        console.log(companies)

        this.companies = companies
        this.showCompanies = companies
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    },

    async getCertificates() {
      const clientId = this.$store.state.client.id

      try {
        let certificates = {}
        certificates.id = '0'
        certificates.name = 'None'
        this.certificates.push(certificates)

        const response = await Api().get('certificates/' + clientId)

        this.certificates = response.data

        // for (let i in response.data) {
        //   certificates = {}
        //   certificates.id = response.data[i].id
        //   certificates.name = response.data[i].name
        //   this.certificates.push(certificates)
        // }
      } catch (e) {
        console.error(e)
      }
    },

    async resetInvoices() {
      const clientId = this.$store.state.client.id

      try {
        this.loading = true
        console.log('cos', this.companies)

        const response = await Api().put('reset_invoices/' + clientId, this.companies)

        console.log(response)

        this.getCompanies()
      } catch (e) {
        console.error(e)
      }
    },

    editInvoice(item) {
      this.sendInfo = item
      this.dialog = true
    },

    editCertificate(item) {
      let currentYear = moment().format('YYYY')

      this.sendInfo = item

      this.sendInfo.startDate = '01/01/' + currentYear

      this.sendInfo.noEmail = this.noEmail
      this.certDialog = true
    },

    async sendInvoice() {
      try {
        this.sendInfo.payStatus = true
        this.sendInfo.client = this.$store.state.client
        console.log('cert', this.sendInfo.CertificateId)

        let certificate = this.certificates.find(
          x => x.id === this.sendInfo.CertificateId
        )

        let fullName = this.sendInfo.name.split(' - ')
        this.sendInfo.name = fullName[0] + ' - ' + certificate.name

        let formData = {}
        formData = this.sendInfo

        const response = await Api().put(
          'send_invoice/' + this.sendInfo.id,
          formData
        )

        let objIndex = this.companies.findIndex(
          obj => obj.id == this.sendInfo.id
        )

        this.companies[objIndex].payStatus = true
        this.companies[objIndex].name = this.sendInfo.name
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async sendCertificate() {
      try {
        this.sendInfo.payStatus = true
        this.sendInfo.client = this.$store.state.client

        let certificate = this.certificates.find(
          x => x.id === this.sendInfo.CertificateId
        )
        this.sendInfo.certificate = certificate

        let fullName = this.sendInfo.name.split(' - ')
        this.sendInfo.name = fullName[0] + ' - ' + certificate.name

        let formData = {}
        formData = this.sendInfo

        const response = await Api().put(
          'send_certificate/' + this.sendInfo.id,
          formData
        )

        let objIndex = this.companies.findIndex(
          obj => obj.id == this.sendInfo.id
        )

        this.companies[objIndex].invoice = 'Paid'
        this.companies[objIndex].name = this.sendInfo.name
        this.certDialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    searchCompanies() {
      this.loading = true

      if (this.search) {
        if (this.search.length > 3) {
          let search = this.search.toLowerCase()
          this.team = 'All'

          let companies = _.filter(this.companies, function(obj) {
            if (obj.name.toLowerCase().indexOf(search) !== -1) {
              return obj.name.toLowerCase().indexOf(search) !== -1
            }
          })

          this.showCompanies = companies
        }
      } else {
        this.showCompanies = this.companies
      }

      this.loading = false
    },

    clearMessage() {
      this.search = ''
      this.showCompanies = this.companies
    },
  },
}
</script>
